<template>
  <div style="width: calc(100% - 70px); height: calc(100% - 20px)">
    <div style="height: 100%">
      <Templates
        :containerHeight="'calc(100% - 20px) !important'"
        filter="presets"
        :selectMode="true"
        :dense="true"
        @selected="selectPresets" />
    </div>
  </div>
</template>
<script setup>
import { onMounted, ref, defineProps, defineAsyncComponent } from 'vue';

// Use dynamic import to avoid bundling Templates into main chunk
const Templates = defineAsyncComponent(
  () => import('../../Templates/Templates.vue')
);

const props = defineProps([
  'customState',
  'userEditObj',
  'qid',
  'channel_did',
  'containerHeight',
]);

function selectPresets(newVal) {
  props.customState.preset_ids = newVal;
}

onMounted(() => {
  console.log('mounted tab 3: Create Scene From Presets');
});
</script>

<style scoped></style>
